import { Component, OnInit, OnDestroy, Directive, Input, HostListener, ViewChild, ViewEncapsulation, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, NgControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { CognitoUtil } from '../../../../shared/services/cognito.service';
import { CalendarEvent } from 'angular-calendar';
import { CaseService } from '../../../../shared/services/case.service';
import { CalendarEventsService } from '../../../../shared/services/calendarEvent.service';
import { CalendarEventModel } from '../calendar-view/event.model';
import { Event } from '../../../../shared/models/event';
import { Case } from '../../../../shared/models/case';
import { CaseContact } from '../../../../shared/models/caseContact';
import { LocalUserService } from '../../../../shared/services/localUser';
import { MatColors } from '../../../../../core/matColors';
import 'rxjs/Rx';
import { environment } from '../../../../../../environments/environment';
import { ConfirmationDialogComponent } from '../../../../shared/dialog/confirmation-dialog/confirmation-dialog.component';
import { UserService } from 'app/main/shared/services/user.service';
import * as moment from 'moment';

@Component({
  selector: 'eguard-calendar-event-form-dialog',
  templateUrl: './event-form.component.html',
  styleUrls: ['./event-form.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    LocalUserService
  ]
})
export class EguardCalendarEventFormatialogComponent implements OnInit {
  event: CalendarEvent;

  dialogTitle: string;

  eventForm: FormGroup;
  taskForm: FormGroup;

  action: string;

  userId: string;
  orgId: string;

  isLoading = false;
  role: string;
  userDetails: any;
  token: string;
  uiError: string;

  loading = false;

  casesArray: Case[];

  caseContacts: CaseContact[];

  usersMap: Object = {};

  error: string;

  statusType: boolean;

  eventType = null;
  createdById = '';
  currentDate;

  locations = [
    { value: 'np', viewValue: 'North Providence Town Hall' },
    { value: 'cc', viewValue: 'Conference Call' },
    { value: 'vc', viewValue: 'Video Call' }
  ];

  colors = {
    event: {
      primary: '#1e90ff',
      secondary: '#D1E8FF'
    },
    task: {
      primary: '#36B73D',
      secondary: '#BCFFB4'
    }
  };

  constructor(
    public dialogRef: MatDialogRef<EguardCalendarEventFormatialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private formBuilder: FormBuilder,
    private cognitoUtil: CognitoUtil,
    private router: Router,
    private caseService: CaseService,
    private calendarEventsService: CalendarEventsService,
    public snackBar: MatSnackBar,
    private localUser: LocalUserService,
    public dialog: MatDialog,
    private userService: UserService

  ) {
    this.eventType = data.statusType;

    this.event = data.event;
    this.dialogTitle = 'Add New Task';
    this.createdById = this.data.createdBy;
    this.action = data.action;
    this.casesArray = data.cases;
    (this.eventType === 'event') ? this.statusType = true : this.statusType = false;
    if (this.casesArray.length > 0) {
      if (this.role === 'CLERK' || this.role === 'JUDGE') {
        this.showCases();
      }
      else {
        this.getUserCases();
      }
    }

    if (this.action === 'edit') {
      this.dialogTitle = this.event.title;
    }
    else {

      if (this.eventType === 'event') {
        this.dialogTitle = 'Add New Event';
      }
      else {
        this.dialogTitle = 'Add New Task';
      }

      this.event = new CalendarEventModel({
        start: this.startAddDate(),
        end: this.endAddDate()
      });
    }

    switch (this.eventType) {

      case 'event':
        this.createEventForm();
        break;

      case 'task':
        this.createTaskForm();
        break;

    }


  }

  ngOnInit() {
    this.userId = this.localUser.getUserId();
    this.orgId = this.localUser.getOrganizationId();
    this.role = this.localUser.getRole();


  }

  ngOnChanges() {

  }

  startAddDate() {

    this.currentDate = new Date();
    let minutes = this.currentDate.getMinutes();

    if (minutes <= 30 && minutes !== 0) {
      let start = new Date(this.currentDate.setMinutes(30));
      // this.eventForm.controls['start'].setValue(start);
      return start;
    } else if (minutes < 60 && minutes !== 0) {
      let start = new Date(this.currentDate.setMinutes(60));
      //  this.eventForm.controls['start'].setValue(start);
      return start;
    } else {

      let start = new Date(this.currentDate);
      return start;
    }


  }

  endAddDate() {
    let startDate = this.startAddDate();
    return startDate;

  }
  saveEvent() {

    this.uiError = '';
    this.loading = true;

    let eventRequest = this.eventForm.value;

    let allDay = false;
    let startTime = eventRequest.start;
    let endTime = eventRequest.end;
    let currentTime = new Date()
    let validateStartTime = moment(startTime).hour();
    let validateEndTime = moment(endTime).hour();

    if (currentTime > startTime) {
      this.uiError = 'Date and Time should be greater then current date & Time';
      this.loading = false;
      return;
    }
    if (endTime < startTime) {
      console.log('END TIME IS BEFORE START IDIOT');
      this.uiError = 'Endtime can not be before start';
      this.loading = false;
      return;
    }

    if (validateStartTime < 9 || validateEndTime > 18) {
      this.uiError = 'Select the time 9 AM to 6 PM';
      this.loading = false;
      return;
    }

    if (startTime === endTime) {
      this.uiError = 'Endtime can not be before start';
    }

    let sendData = {
      'title': eventRequest.title,
      'start': startTime,
      'end': endTime,
      'type': 'EVENT',
      'allDay': allDay,
      'color': {
        'primary': this.colors.event.primary,
        'secondary': this.colors.event.secondary
      },
      'draggable': true,
      'meta': {
        'location': eventRequest.meta.location,
        'notes': eventRequest.meta.notes,
        'cases': eventRequest.meta.cases,
        'user_ids': eventRequest.meta.user_ids
      },
      'created_by': this.userId
    };

    if (this.role === 'CLERK' || this.role === 'JUDGE') {
      this.calendarEventsService.postEvent(sendData, this.userId, this.orgId)
        .subscribe(
          data => {
            this.loading = false;
            this.dialogRef.close();
          }, Error => {
            this.loading = false;
            console.log(Error);
            this.error = 'This page had an error please refresh if this continues contact support';
            this.snackBar.open(this.error, '', {
              duration: environment.snackBarErrorLength,
            });
          });
    }
    else {
      this.calendarEventsService.postUserEvent(sendData, this.userId)
        .subscribe(
          data => {
            this.loading = false;
            this.dialogRef.close(true);
          }, Error => {
            this.loading = false;
            console.log(Error);
            this.error = 'This page had an error please refresh if this continues contact support';
            this.snackBar.open(this.error, '', {
              duration: environment.snackBarErrorLength,
            });
          });
    }
  }

  putEvent() {
    this.loading = true;
    this.uiError = '';

    let eventRequest = this.eventForm.value;

    let allDay = false;
    let startTime = eventRequest.start;
    let endTime = eventRequest.end;

    let currentTime = new Date()
    if (currentTime > startTime) {
      this.uiError = 'Date and Time should be greater then current date & Time';
      this.loading = false;
      return;
    }
    if (endTime < startTime) {
      console.log('END TIME IS BEFORE START IDIOT');
      this.uiError = 'Endtime can not be before start';
      this.loading = false;
      return;
    }

    if (startTime === endTime) {
      allDay = true;
    }

    let sendData = {
      'title': eventRequest.title,
      'start': startTime,
      'end': endTime,
      'allDay': allDay,
      'color': {
        'primary': eventRequest.color.primary,
        'secondary': eventRequest.color.secondary
      },
      'draggable': true,
      'meta': {
        'location': eventRequest.meta.location,
        'notes': eventRequest.meta.notes,
        'cases': eventRequest.meta.cases,
        'user_ids': eventRequest.meta.user_ids
      },
      'modified_by': this.userId
    };

    this.calendarEventsService.putEvent(sendData, this.event.meta.id, this.userId, this.orgId)
      .subscribe(
        data => {
          this.loading = false;
          this.dialogRef.close();
        }, Error => {
          this.loading = false;
          console.log(Error);
          this.error = 'This page had an error please refresh if this continues contact support';
          this.snackBar.open(this.error, '', {
            duration: environment.snackBarErrorLength,
          });
        });

  }

  deleteEvent() {
    const confirmDialog = this.dialog.open(ConfirmationDialogComponent,{
      panelClass:"confirmDetails"

    });
    confirmDialog.componentInstance.msg = `Are you sure to want to remove this ${this.data.statusType} ?`;

    confirmDialog.afterClosed().subscribe(response => {
      if (response == true) {
        this.dialogRef.close(true);
        this.calendarEventsService.deleteEvent(this.orgId, this.event.meta.id)
          .subscribe(
            data => {

            }, Error => {
              this.dialogRef.close(true);
              console.log(Error);
              this.error = 'This page had an error please refresh if this continues contact support';
              // this.snackBar.open(this.error, '', {
              //   duration: environment.snackBarErrorLength,
              // });
            });
      }
    });

  }

  createEventForm() {
    if (!this.event.title.length) {
      this.event.end = new Date(this.event.end.getTime() + 1800000);
    }
    else {
      this.event.end = new Date(this.event.end.getTime());
    }

    this.eventForm = new FormGroup({
      title: new FormControl(this.event.title),
      start: new FormControl(this.event.start),
      end: new FormControl(this.event.end),
      allDay: new FormControl(this.event.allDay),
      color: this.formBuilder.group({
        primary: new FormControl(this.event.color.primary),
        secondary: new FormControl(this.event.color.secondary)
      }),
      meta:
        this.formBuilder.group({
          location: new FormControl(this.event.meta.location),
          notes: new FormControl(this.event.meta.notes),
          cases: new FormControl(this.event.meta.cases),
          user_ids: new FormControl(this.event.meta.user_ids),
          user_id: new FormControl(this.event.meta.user_ids),
        })
    });
  }

  createTaskForm() {
    this.taskForm = new FormGroup({
      title: new FormControl(this.event.title),
      start: new FormControl(this.event.start),
      color: this.formBuilder.group({
        primary: new FormControl(this.event.color.primary),
        secondary: new FormControl(this.event.color.secondary)
      }),
      meta:
        this.formBuilder.group({
          notes: new FormControl(this.event.meta.notes),
          user_id: new FormControl(this.event.meta.user_ids),
        })
    });
  }

  saveTask() {
    this.loading = true;
    let eventRequest = this.taskForm.value;


    let startTime = eventRequest.start;

    let sendData = {
      'title': eventRequest.title,
      'start': startTime,
      'type': 'TASK',
      'allDay': false,
      'color': {
        'primary': this.colors.task.primary,
        'secondary': this.colors.task.secondary
      },
      'draggable': true,
      'meta': {
        'location': '',
        'notes': eventRequest.meta.notes,
        'cases': ''
      },
      'created_by': this.userId
    };

    if (this.role === 'CLERK' || this.role === 'JUDGE') {
      this.calendarEventsService.postEvent(sendData, this.userId, this.orgId)
        .subscribe(
          data => {
            this.loading = false;
            this.dialogRef.close();
          }, Error => {
            this.loading = false;
            console.log(Error);
            this.error = 'This page had an error please refresh if this continues contact support';
            this.snackBar.open(this.error, '', {
              duration: environment.snackBarErrorLength,
            });
          });
    }
    else {
      this.calendarEventsService.postUserEvent(sendData, this.userId)
        .subscribe(
          data => {
            this.dialogRef.close();
            this.loading = false;
          }, Error => {
            console.log(Error);
            this.loading = false;
            this.error = 'This page had an error please refresh if this continues contact support';
            this.snackBar.open(this.error, '', {
              duration: environment.snackBarErrorLength,
            });
          });
    }
  }

  putTask() {
    this.loading = true;
    let eventRequest = this.taskForm.value;

    let startTime = eventRequest.start;

    let sendData = {
      'title': eventRequest.title,
      'start': startTime,
      'created_by': this.userId,
      'type': 'TASK',
      'allDay': false,
      'color': {
        'primary': this.colors.task.primary,
        'secondary': this.colors.task.secondary
      },
      'draggable': true,
      'meta': {
        'location': '',
        'notes': eventRequest.meta.notes,
        'cases': ''
      },
      'modified_by': this.userId
    };

    this.calendarEventsService.putEvent(sendData, this.event.meta.id, this.userId, this.orgId)
      .subscribe(
        data => {
          this.loading = false;
          this.dialogRef.close();
        }, Error => {
          console.log(Error);
          this.loading = false;
          this.error = 'This page had an error please refresh if this continues contact support';
          this.snackBar.open(this.error, '', {
            duration: environment.snackBarErrorLength,
          });
        });
  }

  showCases() {
    this.isLoading = true;
    // this.caseService.getAllCases(this.orgId)
    //   .subscribe(result => {
    //     this.casesArray = result;
    // map for the users.
    for (let i = 0; i < this.casesArray.length; i++) {
      this.usersMap[this.casesArray[i].id] = this.casesArray[i].contacts;
    }
    if (this.action === 'edit' || this.action === 'event') {
      this.caseContacts = this.usersMap[this.event.meta.cases];
      this.isLoading = false;
    }
    this.isLoading = false;

    // },
    //   Error => {
    //   });
  }

  getUserCases() {
    // this.caseService.getCasesByUserId(this.orgId, this.userId)
    //   .subscribe(result => {
    //     this.casesArray = result;
    // map for the users.
    for (let i = 0; i < this.casesArray.length; i++) {
      this.usersMap[this.casesArray[i].id] = this.casesArray[i].contacts;
    }
    if (this.action === 'edit' || this.action === 'event') {
      this.caseContacts = this.usersMap[this.event.meta.cases];
    }
    // }, Error => {
    // });
  }

  showContacts(value) {
    let userIds = []
    this.usersMap[value].forEach(user => {
           if (user.user_id!=null){
        userIds.push(user.user_id)
      }
      
    })
    this.isLoading = true;
    this.userService.getMultipleUserDetails(userIds).subscribe(users => {
      this.caseContacts = users
      this.isLoading = false;
    })
    this.caseContacts = this.usersMap[value];
  }

}







// WEBPACK FOOTER //
// ./src/app/main/content/common/calendar/event-form/event-form.component.ts